"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var iris_1 = require("iris");
var TransportAvailabilityApi = /** @class */ (function () {
    function TransportAvailabilityApi() {
        // state defaults
        this.state = {
            flight: false,
            flex: false,
            rail: false,
            railAndFly: false,
            none: true,
        };
        this.getters = {
            'transportAvailabilities/getFlex': function (state) {
                return state.flex;
            },
            'transportAvailabilities/getFlight': function (state) {
                return state.flight;
            },
            'transportAvailabilities/getRail': function (state) {
                return state.rail;
            },
            'transportAvailabilities/getRailAndFly': function (state) {
                return state.railAndFly;
            },
            'transportAvailabilities/getAll': function (state) {
                return state;
            },
            'transportAvailabilities/getNone': function (state) {
                return {
                    none: state.none,
                };
            },
            'transportAvailabilities/getTransports': function (state) {
                return {
                    flight: state.flight,
                    flex: state.flex,
                    rail: state.rail,
                    railAndFly: state.railAndFly,
                    none: state.none,
                };
            },
        };
        this.actions = {
            'transportAvailabilities/findTransportAvailabilities': function (_a) {
                var commit = _a.commit, getters = _a.getters;
                return __awaiter(this, void 0, void 0, function () {
                    var persons, cruise, none, irisParams, json, error_1;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                persons = getters['persons/all'];
                                cruise = getters['generalCruise'];
                                none = getters['transport/getTransport'].noneOptions.none;
                                irisParams = {
                                    cruiseID: cruise.id,
                                    priceModel: cruise.priceModel,
                                    cabinCategory: cruise.cabinCategory,
                                    adults: persons.adults,
                                    juveniles: persons.juveniles,
                                    children: persons.children,
                                };
                                _b.label = 1;
                            case 1:
                                _b.trys.push([1, 3, , 4]);
                                commit('transportAvailabilities/SET_NONE', none);
                                return [4 /*yield*/, iris_1.client.transportations(irisParams)];
                            case 2:
                                json = _b.sent();
                                commit('transportAvailabilities/SET_FLEX', json.flex);
                                commit('transportAvailabilities/SET_FLIGHT', json.flight);
                                commit('transportAvailabilities/SET_RAIL', json.rail);
                                commit('transportAvailabilities/SET_RAIL_AND_FLY', json.railAndFlight);
                                return [3 /*break*/, 4];
                            case 3:
                                error_1 = _b.sent();
                                console.log(error_1);
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            },
        };
        this.mutations = {
            'transportAvailabilities/SET_RAIL': function (state, data) {
                state.rail = data;
            },
            'transportAvailabilities/SET_RAIL_AND_FLY': function (state, data) {
                state.railAndFly = data;
            },
            'transportAvailabilities/SET_FLEX': function (state, data) {
                state.flex = data;
            },
            'transportAvailabilities/SET_FLIGHT': function (state, data) {
                state.flight = data;
            },
            'transportAvailabilities/SET_NONE': function (state, data) {
                state.none = data;
            },
        };
    }
    return TransportAvailabilityApi;
}());
exports.TransportAvailabilityApi = TransportAvailabilityApi;
//# sourceMappingURL=transport_availability.js.map